import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M10.375 1.844H8.976l-.68-1.02A.66.66 0 0 0 7.75.53h-3.5a.66.66 0 0 0-.547.292l-.68 1.02H1.625A1.53 1.53 0 0 0 .094 3.376V9.5a1.53 1.53 0 0 0 1.531 1.531h8.75A1.53 1.53 0 0 0 11.906 9.5V3.375a1.53 1.53 0 0 0-1.531-1.531m.219 7.656a.22.22 0 0 1-.219.219h-8.75a.22.22 0 0 1-.219-.219V3.375a.22.22 0 0 1 .219-.219h1.75a.66.66 0 0 0 .547-.292l.68-1.02h2.796l.68 1.02a.66.66 0 0 0 .547.292h1.75a.22.22 0 0 1 .219.219zM6 3.594a2.625 2.625 0 1 0 0 5.25 2.625 2.625 0 0 0 0-5.25M6 7.53a1.313 1.313 0 1 1 0-2.625 1.313 1.313 0 0 1 0 2.625" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }